module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/juc/juc.component.scss
// module id = ./src/app/juc/juc.component.scss
// module chunks = main